<template>
  <div style="width: 100%">
    <!-- note- ^^this unlabeled div does not exist in brig-->

    <span class="rfmodal-close inline-flex flex-row-reverse">
      <v-icon
        v-if="!hideCloseButton && closeButtonEnabled"
        id="rfmodal-close-icon"
        class="my-auto"
        :style="{ color: fillColor }"
      >
        md:close
      </v-icon>
      <RfPromptTimeout :actions="actions" class="my-auto mr-2" newVariant />
    </span>
    <div v-if="isVideo" class="video-volume-control">
      <span class="video-volume-up">
        <v-icon
          v-if="actions.rf_settings_video_muted === 'true'"
          size="24"
          :style="{ color: fillColor }"
        >
          md:volume_off
        </v-icon>
        <v-icon v-else size="24" class="video-volume-up" :style="{ color: fillColor }"
          >md:volume_up</v-icon
        >
      </span>
    </div>
    <div class="rfmodal-inner-wrapper">
      <div :class="backgroundContentAlignmentClass">
        <div
          :class="textContainerClasses"
          :style="{ width: actions.rf_settings_text_container_max_width }"
        >
          <div>
            <div>
              <!-- extra div layers to match brig ^^ -->
              <div class="rfmodal-header">
                <h1 :style="titleStyle" v-html="parsedRetentionTitle"></h1>
              </div>
              <div class="rfmodal-body">
                <RfBodyCountdown :actions="actions" />
                <div class="rfmodal-message" :style="messageStyle" v-html="message"></div>
              </div>
            </div>
          </div>
          <RfPromoInputsPreview :actions="actions" />
          <div class="rfmodal-footer">
            <RfRetentionMessageButton v-if="!hideButtons" :actions="actions" :model="model" />
          </div>
        </div>
        <div v-if="!isVideo" :style="columnspacerWidth" class="rfmodal-colm-spacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import PromoPreviewMixin from "@/utils/PromoPreviewMixin";
import RfRetentionMessageButton from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionMessageButton.vue";
import RfPromoInputsPreview from "@/components/RfPathCreate/RfRetentionActions/components/RfPromoInputsPreview.vue";
import RfBodyCountdown from "../RfBodyCountdown.vue";
import RfPromptTimeout from "./RfPromptTimeout.vue";
import { useAppsStore } from "@/pinia/appsStore";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionBanner",
  components: { RfRetentionMessageButton, RfPromoInputsPreview, RfBodyCountdown, RfPromptTimeout },
  mixins: [PromoPreviewMixin],
  props: {
    model: { type: Object, default: null },
    actions: { type: Object, default: null },
    isVideo: { type: Boolean, default: false },
    hideCloseButton: { type: Boolean, default: false },
    hideButtons: { type: Boolean, default: false },
  },
  setup: () => ({ appsStore: useAppsStore(), liquidContextStore: useLiquidContextStore() }),
  computed: {
    parsedRetentionTitle() {
      return this.liquidContextStore.liquidify(this.actions?.rf_retention_title);
    },
    messageStyle() {
      return {
        "font-size": this.actions.rf_settings_message_font_size,
        "color": this.fillColor,
      };
    },
    titleStyle() {
      return {
        "font-size": this.actions.rf_settings_title_font_size,
        "color": this.fillColor,
        "margin-top": this.actions.rf_settings_title_padding_top,
      };
    },
    textContainerClasses() {
      return [
        {
          "rfmodal-text-container": true,
        },
        {
          "rf-banner-text-horizontal": this.actions.rf_banner_display === "horizontal",
          "rf-banner-text-vertical": this.actions.rf_banner_display === "vertical",
          "rf-banner-text-reversed": `${this.actions.rf_banner_position_reverse}` === "true",
        },
        {
          "left-align-mode": this.actions.rf_retention_align === "left",
          "center-align-mode": this.actions.rf_retention_align === "center",
          "right-align-mode": this.actions.rf_retention_align === "right",
        },
        {},
      ];
    },
    backgroundContentAlignmentClass() {
      if (this.actions.rf_retention_img_align === "left") {
        return "rfmodal-content-wrapper b-left-align";
      }
      return "rfmodal-content-wrapper b-right-align";
    },
    columnspacerWidth() {
      return {
        width: `calc(100% - ${this.actions.rf_settings_text_container_max_width})`,
        height: "4px",
      };
    },
  },
};
</script>

<style>
.video-volume-control {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
